"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const schema_1 = require("../schema");
class AnySchema extends schema_1.Schema {
    expected() {
        return 'anything';
    }
    validate() {
        return true;
    }
}
exports.AnySchema = AnySchema;
